import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { configure } from 'mobx';

import App from './App';

import { elementHasSize } from '@egr/xbox/egr-gui-utils/MiscHelper';
import { developmentMode, getEnvVar, PUBLIC_URL } from '@egr/xbox/utils/ReactScriptHelper';
import { initInstance, setLanguage } from '@egr/xbox/base-app/i18n';

import { wcfConfig } from '@egr/wcf/modules/utils';

declare global {
    interface Window {
        _App: App;
    }
}

configure(developmentMode ? {
    enforceActions: 'observed',
    computedRequiresReaction: true,
} : {
    enforceActions: 'observed'
});

wcfConfig.ajaxDefaultOptions.timeout = 120000;
wcfConfig.dataPath = PUBLIC_URL + '/w-cf/data/';
wcfConfig.libsPath = PUBLIC_URL + '/w-cf/libs/';

async function renderApp(): Promise<void> {
    await initInstance();
    await setLanguage(getEnvVar('lang', 'en'));

    const app: JSX.Element = (
        <App
            ref={(appRef: App): void => {
                window._App = appRef;
            }}
        />
    );

    const rootElement: HTMLElement = document.getElementById('root') as HTMLElement;
    ReactDOM.render(app, rootElement);
}

async function run(): Promise<void> {
    await elementHasSize(document.body);
    void renderApp();
}

void run();